import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { useFieldContext } from "./form-context";

export function FormCheckbox({ label, id, description }: { label: string; id: string; description?: string }) {
  const field = useFieldContext<string[]>();
  return (
    <div className="flex flex-row gap-2">
      <Checkbox
        id={id}
        checked={field.state.value?.includes(id)}
        onCheckedChange={(checked) =>
          field.handleChange(checked ? [...field.state.value, id] : field.state.value.filter((value) => value !== id))
        }
      />
      <Label htmlFor={id}>{label}</Label>
      {description && <div className="text-sm form-description">{description}</div>}
    </div>
  );
}
